import request from '@/utils/request'

// 汇率列表
export const getExchangeRate = () =>
  request({
    url: '/manage/exchange-rate',
    method: 'get'
  })

// 创建汇率
export const addExchangeRate = (data: any) =>
  request({
    url: '/manage/exchange-rate',
    method: 'post',
    data
  })

// 编辑汇率
export const editExchangeRate = (data: any) =>
  request({
    url: '/manage/exchange-rate/' + data.id,
    method: 'patch',
    data
  })

// 删除汇率
export const delExchangeRate = (data: any) =>
  request({
    url: '/manage/exchange-rate/' + data.id,
    method: 'delete',
    data
  })

// 获取Telegram商户群组
export const getTelegroup = () =>
  request({
    url: '/manage/tele-group',
    method: 'get'
  })

// 发送 Telegram 消息
export const setSendMessage = (data: any) =>
  request({
    url: '/manage/send-msg',
    method: 'post',
    data
  })

  // 商户机器人群组接口
export const getGelegramGroup = (params: any) =>
request({
  url: '/manage/telegram-bot-group',
  method: 'get',
  params
})

  // 商户机器人群组 编辑群组接口
  export const editGelegramGroup = (data: any) =>
  request({
    url: '/manage/telegram-bot-group/' + data.id,
    method: 'patch',
    data
  })

  // 商户机器人群组 删除群组接口
  export const delGelegramGroup = (params: any) =>
  request({
    url: '/manage/telegram-bot-group/' + params.id,
    method: 'delete'
  })

  // 群组分类接口-列表
  export const getGroupCategoryList = (params: any) =>
  request({
    url: '/manage/telegram-bot-group-category',
    method: 'get',
    params
  })

  // 创建机器人群组分类接口
  export const addGroupCategoryList = (data: any) =>
  request({
    url: '/manage/telegram-bot-group-category',
    method: 'post',
    data
  })

  // 删除机器人群组分类接口
  export const delGroupCategoryList = (params: any) =>
  request({
    url: 'manage/telegram-bot-group-category/' + params.id,
    method: 'delete'
  })

  // 更新机器人群组分类接口
  export const patchGroupCategoryList = (data: any) =>
  request({
    url: 'manage/telegram-bot-group-category/' + data.id,
    method: 'patch',
    data
  })
